import { type InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string | null;
  helperText?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helperText, className = '', id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-text-muted dark:text-neutral-400 mb-1.5"
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={`
            w-full px-4 py-3.5 h-13
            bg-white/90 dark:bg-neutral-800/90 border-2 rounded-xl
            text-text-dark dark:text-neutral-200 placeholder-text-muted dark:placeholder-neutral-500
            transition-all duration-200 ease-out
            focus:outline-none focus:border-game-blue focus:bg-white dark:focus:bg-neutral-800
            focus:shadow-[0_0_0_4px_rgba(139,184,234,0.2)]
            disabled:opacity-50 disabled:cursor-not-allowed
            ${error ? 'border-accent-error' : 'border-surface-border/80 dark:border-neutral-600/80 hover:border-game-blue/60 hover:bg-white dark:hover:bg-neutral-800'}
            ${className}
          `}
          {...props}
        />
        {error && (
          <p className="mt-1.5 text-sm text-accent-error">{error}</p>
        )}
        {helperText && !error && (
          <p className="mt-1.5 text-sm text-text-muted dark:text-neutral-400">{helperText}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
